import Vue from 'vue'
import purchaseView from '../../../../components/reimbursement/purchaseView'

export default {
  name: 'purchaseOrderList',
  components: {
    Vue,
    purchaseView
  },
  data() {
    return {
      tableHeight: window.innerHeight - 190,
      // 遮罩层
      loading: true,
      // 选中数组
      purchaseOrderList: [],
      //主页数据条数
      total: 0,
      currentPage: 1,
      limit: 20,
      //供应商数组
      gys: [],
      //主表单据号数组
      ids: [],
      //借款人数组
      jkr: [],
      //通过金额的数组
      tgje: [],
      //错误提示
      showError: false,
      showTableDataError: false,
      centerDialogVisible: false,
      cdxj: false,
      jsfk: true,
      //错误提示
      errorTitle: '',
      // 显示搜索条件
      showSearch: true,
      //第三个框的数据
      thirdTableToCheck: {
        rowIndex: 0,
        checkList: [],
        //搜索按钮
        serialNumber: undefined
      },
      secondTable: {
        totals: 0,
        tableData: []
      },
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      isOpen: false,
      openTow: false,
      // 查询参数
      queryParams: {
        gys: undefined,
        lrrname: undefined,
        settleSign: '未分款'
      },
      modesSelect: {
        quickMode: '6',
        settleMode: '银行承兑汇票'
      },
      // 表单参数
      form: {},
      statusOptions: [
        {
          dictLabel: '费用报销单',
          dictValue: '费用报销单'

        }, {
          dictLabel: '差率报销单',
          dictValue: '差率报销单'
        }
      ],
      settleModeList: [
        {
          dictLabel: '银行承兑汇票',
          dictValue: '银行承兑汇票'
        },
        {
          dictLabel: '商业承兑汇票',
          dictValue: '商业承兑汇票'
        },
        {
          dictLabel: '承兑汇票+现金',
          dictValue: '承兑汇票+现金'
        },
        {
          dictLabel: '现金',
          dictValue: '现金'
        }
      ],
      quickMode: [
        {
          dictLabel: '应付款',
          dictValue: '6'
        },
        {
          dictLabel: '预付款',
          dictValue: '5'
        }
      ],
      settleSignList: [
        {
          dictLabel: '全部',
          dictValue: '全部'

        }, {
          dictLabel: '未分款',
          dictValue: '未分款'
        }, {
          dictLabel: '已分款',
          dictValue: '已分款'
        }
      ],
      // 表单校验
      pageSizes: {
        type: Array,
        default() {
          return [100, 200, 30]
        }
      },
      billTemplate: {
        rowData: {},
        purchaseShow: false
      }
    }
  },
  created() {
    this.getList()
    this.getTableDate()
  },
  computed: {
    reverseText: function() {
      let amount = 0
      for (let i = 0; i < this.secondTable.tableData.length - 1; i++) {
        amount += parseFloat(this.secondTable.tableData[i].invoiceAmount)
      }
      return amount
    }
  },
  methods: {

    dateFormat(row) {
      const date = new Date(row.rq)
      let d = date.getFullYear() + '-'
      if ((date.getMonth() + 1) < 10) {
        d += '0' + (date.getMonth() + 1)
      } else {
        d += (date.getMonth() + 1)
      }
      d += '-'
      if (date.getDate() < 10) {
        d += '0' + date.getDate()
      } else {
        d += date.getDate()
      }
      return d
    },
    getList() {
      const data = {
        settleSign: this.queryParams.settleSign,
        lrrname: this.queryParams.lrrname ? this.queryParams.lrrname : null,
        gys: this.queryParams.gys ? this.queryParams.gys : null,
        currentPage: this.currentPage,
        limit: this.limit
      }
      this.$post('/fesback/Financial/PurchaseOrderList.z', data).then(request => {
        this.purchaseOrderList = request.data.data
        this.total = request.data.count
        this.loading = false
        this.$message({
          message: request.message,
          type: 'success'
        })
      })
    },
    cellStyle(row, column, rowIndex, columnIndex) {
      return 'padding: 6px 0;'
    },
    handleSizeChange(val) { // 每页多少条
      this.limit = val
      this.getList()
    },
    handleCurrentChange(val) { // 当前页
      this.currentPage = val
      this.getList()
    },
    getTableDate() {
      for (let i = 0; i < 5; i++) {
        this.secondTable.tableData.push({
          index: i,
          serialNumber: '',
          invoiceAmount: '',
          financeCustomerName: ''
        })
      }
    },
    handleQuery() {
      this.currentPage = 1
      this.getList()
      this.settleSignChange(this.queryParams.settleSign)
    },
    checkQuery() {
      const rowIndex = this.thirdTableToCheck.rowIndex
      this.$post('/fesback/Purchase/checkList.z', this.thirdTableToCheck).then(response => {
        this.thirdTableToCheck.checkList = response['data']['data']
        this.thirdTableToCheck.rowIndex = rowIndex
        this.loading = false
      })
    },

    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.djh)
      this.gys = selection.map(item => item.gys)
      this.tgje = selection.map(item => item.tgje)
      this.multiple = !selection.length
    },
    // 承兑支付确认操作  承兑标识  1
    handlegGenerateBycd(row) {
      if (this.ids.length === 0) {
        this.showError = true
        this.errorTitle = '请至少勾选一条单据信息'
        this.timeOUtHideError('showError')
        return false
      }
      const djh = row.djh || this.ids
      const djhs = djh.join(',')
      // const params = {
      //   djhs: djhs,
      //   settleMode: '1'
      // }
      const _this = this
      this.$confirm('是否进行支付确认?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        const loading = _this.$loading({
          lock: true,
          text: '请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        _this.$post('/fesback/bfinance/paymentSave.z?djhs=' + djhs + '&settleMode=' + 1).then(request => {
          console.log(request.data.messages[0])
          loading.close()
          _this.getList()
          if (request.code === '500') {
            _this.$message.error(request.message + '/' + request.data.messages[0])
          } else {
            _this.$message({
              type: 'success',
              message: request.message + '/' + request.data.messages[0]
            })
          }
        })
      })
    },
    // 现金支付确认操作  现金标识 2
    handlegGenerateByxj(row) {
      if (this.ids.length === 0) {
        this.showError = true
        this.errorTitle = '请至少勾选一条单据信息'
        this.timeOUtHideError('showError')
        return false
      }
      const djh = row.djh || this.ids
      const djhs = djh.join(',')
      // const params = {
      //   djhs: djhs,
      //   settleMode: '2'
      // }
      const _this = this
      this.$confirm('是否进行支付确认?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        const loading = _this.$loading({
          lock: true,
          text: '请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        _this.$post('/fesback/bfinance/paymentSave.z?djhs=' + djhs + '&settleMode=' + 2).then(request => {
          loading.close()
          _this.getList()
          if (request.code === '500') {
            if (request.data !== '' && request.data && request.data.message && request.data.message.length > 0) {
              console.log(request.data.messages[0])
              _this.$message.error(request.data.messages[0])
            } else {
              _this.$message.error(request.message)
            }
          } else {
            _this.$message({
              type: 'success',
              message: request.message + '/' + request.data.messages[0]
            })
          }
        })
      })
    },
    addPayment() {
      if (this.ids.length === 0) {
        this.showError = true
        this.errorTitle = '请至少勾选一条单据信息'
        this.timeOUtHideError('showError')
        return false
      }
      this.showError = false
      const djh = this.ids
      const djhs = djh.join(',')
      const gys = Array.from(new Set(this.gys))
      if (gys.length > 1) {
        this.showError = true
        this.errorTitle = '供应商信息不一致'
        this.timeOUtHideError('showError')
        return false
      }
      const tgje = this.tgje
      let thjeSum = 0
      tgje.forEach(function(val) {
        thjeSum += val
      })
      this.secondTable.totals = '供应商名称:' + this.gys.slice(0, 1) + ' 单据号:' + djhs + ' 审批通过金额:' + thjeSum.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.isOpen = true
      this.title = '申请付款单结算分款'
    },

    /** 重置按钮操作 */
    resetQuery() {
      this.$refs['queryForm'].resetFields()
      this.handleQuery()
    },

    /**增加行操作  */
    handleAddDetails() {
      const temp = {
        index: this.secondTable.tableData.length,
        serialNumber: '',
        invoiceAmount: '',
        financeCustomerName: ''
      }
      this.secondTable.tableData.push(temp)
    },
    //删除行操作
    handleDelDetails() {
      if (this.secondTable.tableData.length <= 5) {
        return false
      }
      this.secondTable.tableData.splice(this.secondTable.tableData.length - 1, 1)
    },
    //行内搜索放大镜功能
    queryzp(index) {
      this.openTow = true
      this.title = '承兑票据号列表'
      this.thirdTableToCheck.rowIndex = index
      this.$post('/fesback/Purchase/checkList.z', { currentPage: 1, limit: 5 }).then(response => {
        this.thirdTableToCheck.checkList = response['data']['data']
        this.loading = false
      })
    },
    cancel() {
      this.isOpen = false
    },
    timeOUtHideError(filed) {
      const _this = this
      setTimeout(function() {
        _this[filed] = false
      }, 3000)
    },
    //点击行选中事件
    rowcheck(row, column, event) {
      this.openTow = false
      const index = this.thirdTableToCheck.rowIndex
      const data = this.secondTable.tableData[index]
      Object.keys(data).forEach(function(key) {
        Vue.set(data, key, row[key])
      })
      data['invoiceAmount'] = this.format(data)
      data.index = index
    },
    sumTableData({ columns, data }) {
      const sums = []
      sums.push('合计')
      let sum = 0
      data.forEach(function(value) {
        if (value.invoiceAmount !== '') {
          sum += parseFloat(value.invoiceAmount.replaceAll(',', ''))
        }
      })
      sums.push(sum.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
      sums.push('')
      return sums
    },
    //删除行内数据
    deletezp(index) {
      const data = this.secondTable.tableData[index]
      Object.keys(data).forEach(function(key) {
        data[key] = ''
      })
      data.index = index
    },
    determine() {
      const djh = this.ids
      const djhs = djh.join(',')
      const settleMode = this.modesSelect.settleMode
      const quickMode = this.modesSelect.quickMode
      const serialNumber = []
      this.secondTable.tableData.forEach(function(value) {
        if (value.serialNumber !== null && value.serialNumber !== undefined && value.serialNumber !== '') {
          serialNumber.push(value.serialNumber)
        }
      })
      if (settleMode !== '现金' && serialNumber.length === 0) {
        this.showTableDataError = true
        this.errorTitle = '请填写票据信息'
        this.timeOUtHideError('showTableDataError')
        return false
      }
      const data = {
        maindjh: djhs,
        settleMode: settleMode,
        quicktypeCode: quickMode,
        serialNumber: serialNumber.join(',')
      }
      const _this = this
      this.$confirm('是否确定进行分款?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        const loading = _this.$loading({
          lock: true,
          text: '分款中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        _this.$post('/fesback/Purchase/fksqdSaves.z', data).then(response => {
          loading.close()
          _this.getList()
          _this.isOpen = false
          if (response.code === '500') {
            _this.$message.error(response.message + '/' + response.data.messages[0])
          } else {
            _this.$message({
              message: response.message,
              type: 'success'
            })
          }
        })
      })
    },
    changeSettleMode(field, value) {
      this.modesSelect[field] = value
    },
    settleSignChange(value) {
      if (value === '未分款') {
        this.cdxj = false
        this.jsfk = true
      } else if (value === '已分款') {
        this.cdxj = true
        this.jsfk = false
      } else {
        this.cdxj = false
        this.jsfk = false
      }
    },
    format: function(s) {
      if (s.invoiceAmount !== null && s.invoiceAmount !== '' && s.invoiceAmount !== undefined) {
        return s.invoiceAmount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')//使用正则替换，每隔三个数加一个','
      }
      // eslint-disable-next-line no-return-assign
      return s.invoiceAmount = ''
    },
    seeDocument(row, index) {
      const data = {
        djh: row.djh,
        documentType: 'wzyb'
      }
      /* 查询单据流程数据 */
      this.$post('/fesback/purchase/findPurchaseByData.z', data).then(response => {
        this.billTemplate.rowData = response.data
        this.billTemplate.purchaseShow = true
      })
    }
  }
}
//
//
//
//
//
//
//
// export function purchaseOrderLists(query) {
//   return request({
//     url: '/purchase/documentOrderList',
//     method: 'get',
//     params: query
//   })
// }
//
// export function generateVoucher(params) {
//   return request({
//     url: '/bfinance/paymentSave',
//     method: 'get',
//     params: params
//   })
// }
//
// export function fksqdSaves(params) {
//   return request({
//     url: '/fksqd/fksqdSavess',
//     method: 'post',
//     params: params
//   })
// }
//
// export function checkList(query) {
//   return request({
//     url: '/purchase/checkList',
//     method: 'get',
//     params: query
//   })
// }
